export function isAnnotationLocked(annotation) {
    return annotation.annotationLocked === true;
}
export function isAnnotationUnlocked(annotation) {
    return !isAnnotationLocked(annotation);
}
//# sourceMappingURL=annotation-lock.js.map